import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Button } from '../components/ui/button';
import { 
  BookOpen, Clock, CheckCircle2, Users, Award, 
  Code, Brain, Database, Eye, Cpu, Rocket, Briefcase 
} from 'lucide-react';
import { syllabus } from '../data/mock';

const moduleIcons = {
  1: Brain,
  2: Database,
  3: Code,
  4: Cpu,
  5: BookOpen,
  6: Eye,
  7: Rocket,
  8: Briefcase
};

const SyllabusPage = () => {
  const scrollToEnroll = () => {
    window.location.href = '/pricing';
  };

  return (
    <div className="page syllabus-page">
      <Header onEnrollClick={scrollToEnroll} />
      
      <main className="page-content">
        {/* Hero */}
        <section className="page-hero">
          <div className="container">
            <span className="section-tag">Complete Curriculum</span>
            <h1 className="page-title">Course Syllabus</h1>
            <p className="page-subtitle">
              A comprehensive 24-week journey from AI fundamentals to advanced applications
            </p>
            <div className="hero-stats-row">
              <div className="stat-pill">
                <Clock size={16} />
                <span>24 Weeks</span>
              </div>
              <div className="stat-pill">
                <BookOpen size={16} />
                <span>8 Modules</span>
              </div>
              <div className="stat-pill">
                <Users size={16} />
                <span>120+ Hours</span>
              </div>
              <div className="stat-pill">
                <Award size={16} />
                <span>25+ Projects</span>
              </div>
            </div>
          </div>
        </section>

        {/* Detailed Syllabus */}
        <section className="detailed-syllabus">
          <div className="container">
            {syllabus.map((module, index) => {
              const IconComponent = moduleIcons[module.id] || BookOpen;
              return (
                <div key={module.id} className="module-detail-card">
                  <div className="module-header-detail">
                    <div className="module-icon-large">
                      <IconComponent size={32} />
                    </div>
                    <div className="module-meta-detail">
                      <span className="module-number-badge">{module.module}</span>
                      <h2 className="module-title-large">{module.title}</h2>
                      <div className="module-info-row">
                        <span><Clock size={14} /> {module.duration}</span>
                        <span><BookOpen size={14} /> {module.topics.length} lessons</span>
                      </div>
                    </div>
                  </div>
                  
                  <div className="module-topics-grid">
                    {module.topics.map((topic, idx) => (
                      <div key={idx} className="topic-card">
                        <CheckCircle2 className="topic-check" />
                        <span>{topic}</span>
                      </div>
                    ))}
                  </div>

                  {index < syllabus.length - 1 && (
                    <div className="module-connector">
                      <div className="connector-line"></div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </section>

        {/* CTA Section */}
        <section className="syllabus-cta">
          <div className="container">
            <div className="cta-card">
              <h2>Ready to Start Your AI Journey?</h2>
              <p>Join 12,500+ students already learning with WSafe AI ML</p>
              <Link to="/pricing">
                <Button className="btn-primary">
                  View Pricing & Enroll
                </Button>
              </Link>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default SyllabusPage;
